import {observer, inject} from 'mobx-react';
import Nav from 'components/Nav';
import ProductItem from 'components/ProductItem';
import MoreTitle from '../more';
import ModuleTitle from '../ModuleTitle';
@inject(({store}) => ({
    jzbblc: store.jzbblc,
    tabClick: store.tabClick,
    jump: store.jump,
    ymbj: store.ymbj
}))
@observer
class Sponsor extends React.Component {
    state = {
        spread: false
    }

    more = () => {
        this.setState({
            spread: true
        });
    }

    tabClick(keyName, index) {
        this.props.tabClick('jzbblc', keyName, index);
    }

    getTypeValue(data) {
        let dpj = '', lvj = '', result;
        result = data.filter(v => {
            if(v.display === undefined && !v.display.includes('mobile_list')) {
                return false;
            }

            if(v.tag_type === 'shopAllianceCoupon' && v.type === 'sales') {
                !dpj && v.amount && (dpj = (v.reduce_type === 1 ? '每满' : '满') + v.amount + '减' + v.reduce);
                return false;
            }
            if(v.tag_type === 'promotion' && v.type === 'sales') {
                !lvj && v.money && (lvj = '最高 满' + v.money + '减' + v.reduce);
                return false;
            }
            return true;
        });

        let dataSum = [];
        result = result.filter((t) => {
            if(dataSum.includes(t.title)) return false;
            dataSum.push(t.title);
            return true;
        });
        return {
            dpj,
            lvj,
            result
        };
    }
    pRend(data) {
        const {ymbj} = this.props;
        let tags = data.data.tags ? data.data.tags : [];
        const promoteDesc = ymbj.promoteDesc;

        let dpjContent = '', lvjContent = '';
        if(data.tagInfos) {
            let {dpj, lvj, result} = this.getTypeValue(data.tagInfos, 'tag_type', 'shopAllianceCoupon', 'title');
            dpjContent = dpj;
            lvjContent = lvj;
            !tags.length && (tags = result);
        }

        return (
            <div className="pro-info ">
                <div className="tit">{data.title}</div>
                <div className="tags lr-tags">
                    {
                        tags && tags.map((item) => {
                            const text = item.tag || item.title;
                            if(!text) return null;
                            return <div className="tags-item">{text}</div>;
                        })
                    }
                </div>
                <div className="dpmj-item">
                    瓜分可得
                    <span className="line"></span>
                    {lvjContent ? lvjContent : promoteDesc}
                </div>
                <div className={`${dpjContent ? 'dpmj-item': 'empty-item'}`}>
                    {
                        dpjContent ?
                            <div>
                                店铺劵
                                <span className="line"></span>
                                {dpjContent}
                            </div> : ''
                    }
                </div>
                <div className="price-info">
                    <div className="price lr-price">&yen;<span className="num">{data.taocanPrice ? data.taocanPrice : data.price}</span>起</div>
                    <div className={`btn ${data.status === 2 ? 'soldout' : 'lr-btn'}`} >{data.status === 2 ? '已售罄' : '立即购买'}</div>
                </div>
            </div>
        );
    }
    render() {
        const {jzbblc, jump} = this.props;
        const {jzbblcFirstTab, pros} = jzbblc;
        const {spread} = this.state;
        return (
            <div className="m-jzbb-floor m-floor" id="jzbblc">
                <ModuleTitle name="jzbblc"/>
                <Nav
                    tabs={jzbblcFirstTab}
                    tabClick={this.tabClick.bind(this)}
                    navCls="common-navitem"
                    navClsAct="common-navactive"
                    moreCls="common-navitem"
                    dbackCls="common-drawback"
                    keyName="jzbblcFirstTab"
                />
                {
                    pros.length ?
                        <div className="pro-lists">
                            {
                                pros.map((item, index) => {
                                    if(!spread && index > 3) return null;
                                    return <ProductItem
                                        custCls="lr-item"
                                        pRendeStatus={true}
                                        data={item}
                                        jump={() => {
                                            jump(item.jumpInfo, 'TODO_IT');
                                            sendSK('TODO_EID', {
                                                floor: '爸爸楼层',
                                                id: item.id
                                            });
                                        }} key={index}
                                        pRend={this.pRend.bind(this)}
                                    />;
                                })
                            }
                        </div> : ''
                }
                {
                    (pros.length > 4 && !spread) ?
                        <MoreTitle
                            bgUrl={'//s.qunarzz.com/vacation_tuan/2020/06_shuchu/more-bg.png'}
                            text="查看更多"
                            ClickMore={() => {
                                this.more();
                                sendSK('TODO_EID', {
                                    floor: '爸爸楼层'
                                });
                            }}
                        /> : ''
                }
            </div>
        );
    }
}

export default Sponsor;